// base rc-steps 3.3.1
import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export { Step };
export default Steps;
